var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D0CDE1",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003009_3856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6669 19.28V21.28C22.6677 21.4657 22.6297 21.6494 22.5553 21.8195C22.4809 21.9897 22.3718 22.1424 22.235 22.2679C22.0982 22.3934 21.9367 22.489 21.7608 22.5485C21.5849 22.6079 21.3985 22.63 21.2136 22.6133C19.1622 22.3904 17.1916 21.6894 15.4603 20.5667C13.8495 19.5431 12.4838 18.1774 11.4603 16.5667C10.3336 14.8275 9.63244 12.8473 9.41361 10.7866C9.39695 10.6023 9.41886 10.4165 9.47795 10.2411C9.53703 10.0656 9.63199 9.90444 9.75679 9.76773C9.88159 9.63102 10.0335 9.52179 10.2028 9.447C10.3721 9.37221 10.5552 9.33349 10.7403 9.33332H12.7403C13.0638 9.33013 13.3775 9.4447 13.6228 9.65567C13.8681 9.86664 14.0283 10.1596 14.0736 10.48C14.158 11.12 14.3146 11.7485 14.5403 12.3533C14.63 12.5919 14.6494 12.8513 14.5962 13.1006C14.543 13.3499 14.4195 13.5787 14.2403 13.76L13.3936 14.6066C14.3427 16.2757 15.7246 17.6576 17.3936 18.6067L18.2403 17.76C18.4215 17.5807 18.6504 17.4572 18.8997 17.404C19.149 17.3509 19.4083 17.3703 19.6469 17.46C20.2518 17.6857 20.8802 17.8422 21.5203 17.9267C21.8441 17.9723 22.1399 18.1355 22.3513 18.385C22.5627 18.6345 22.6751 18.953 22.6669 19.28Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003009_3856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3cd07be19f6a2f67bde55696f15ca9a5.svg";
export { ForwardRef as ReactComponent };